'use strict';

var $ = require('jquery');
var progress = require('../../utils/progress');
var util = require('../../utils/util');
var toggle = require('../../components/toggle');
var flyin = require('../../flyins/flyin');
var uniform = require('../../components/uniform');
var pdpsize = require('../../components/product/pdpsize');
var gtmTracker = require('../../components/tracking/tracking');
var wishlist = require('../wishlist');
var lazyload = require('../../utils/lazyload');
var imagearrows = require('../../components/image/imagearrows');
var variationValidation = require('./validVariation.js');
var image = require('./image');
var afterpayFlyin = require('../../components/checkout/afterpayFlyin');
var tabbyInfoFlyin = require('../../productdetail/tabbyinfoflyin');
var variationCarousel = require('../../productdetail/variation-carousel');
var activeBubbleIndex = 0;
var stickyPanel = require('../../productdetail/sticky-panel');
var stickyAddToBag = require('../../productdetail/sticky-add-to-bag');
var productZoom = require('./productZoom');
var pdp = require('../../1774/components/pdp');
const {updateAddToCartButtonState} = require('./addToCart');
const googlepay = require('../checkout/googlepay_ui');
const optiTracking = require('../../components/tracking/optimizely');
const cookie = require('../../components/cookie');
const fitPredictor = require('../../components/fit-predictor');
const optiExperiment = require('../../components/optimizelyExperimentation');

import productFlags from '../../spa/components/search/product/components/product-flags';
import {
    initUniversalRecommendations,
    removeUniversalRecommendations
} from '../../constructor-io/helpers/recommendations';

function calculateInfoPanelMargin() {
    let infoPanel = $('.information-panel');

    if (infoPanel.length) {
        let elementWithMargin;
        let lowMsg = $('.in-stock-low-msg');
        let pdpBenefits = $('.pdp-benefits');
        let preOrder = $('.pre-order-product-hint');
        let membersOnly = $('.members-only-product-hint');
        let membersExclusives = $('.member-exclusives-product-hint');
        let storeInventory = $('.fly-in-link-store-inventory-wrapper');

        if (
            storeInventory.length &&
            !storeInventory.parent().hasClass('product-availability-links') &&
            !storeInventory.parent().hasClass('product-availability-links-cosmetics')
        ) {
            elementWithMargin = storeInventory;
        }

        if (lowMsg.length && preOrder.length === 0) {
            elementWithMargin = lowMsg;
        }

        if (pdpBenefits.length === 0 || pdpBenefits.height() === 0) {
            if (preOrder.length) {
                elementWithMargin = preOrder;
            }

            if (membersOnly.length) {
                elementWithMargin = membersOnly;
            }

            if (membersExclusives.length) {
                elementWithMargin = membersExclusives;
            }
        }

        if (elementWithMargin) {
            elementWithMargin.css('margin-bottom', 0);
        }
    }
}

var getParameterByName = function (name, url) {
    var regex;
    var results;
    if (!url) url = window.location.href; // eslint-disable-line no-param-reassign
    name = name.replace(/[[\]]/g, '\\$&'); // eslint-disable-line no-param-reassign
    regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)');
    results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
};

/**
 * @description update product content with new variant from href, load new content to #product-content panel
 * @param {String} href - url of the new product variant
 */

var updateContent = function (href, noHistoryManipulation, newUrl, options, isColorChange, updateDoneCallback) {
    var $pdpForm = $('.pdpForm');
    var qty = $pdpForm.find('input[name="Quantity"]').first().val();
    var params = {
        Quantity: isNaN(qty) ? '1' : qty,
        format: 'ajax',
        productlistid: $pdpForm.find('input[name="productlistid"]').first().val(),
        isColorChange: isColorChange
    };

    progress.show($('#pdpMain'));

    if (href.indexOf('groupSize') < 0) {
        href += '&groupSize=' + $('#groupSize').val(); // eslint-disable-line no-param-reassign
    }

    // update dy delivery message
    var dyDeliveryMsg = '';
    if ($('#dy_delivery-time-msg').length) {
        dyDeliveryMsg = $('#dy_delivery-time-msg').html();
    }

    $.get(util.appendParamsToUrl(href, params)).done(function (res) {
        var result = res.split('%%%%SEPARATOR%%%%');
        var resultLength = result.length;
        var $carouselContainer;

        $('.product-description-content').html(result[0]);
        $('#product-content').html(result[1]);

        removeUniversalRecommendations();

        if (!noHistoryManipulation && history.pushState) {
            history.pushState(href, null, newUrl || href);
        }
        if (options && options.uniform !== false) {
            uniform();
        }

        // Required for scroll calculation when user is changing color.
        let singleImageContainerHeigth;
        let initialImagesContainerHeight;

        // Scroll before the image replacement.
        let windowScrollTop = window.pageYOffset;

        let initialImageContainer = $('.thumbnail-container-slider .slick-list .slick-slide');
        const isGooglePayAllowed = $('#is-google-pay-allowed').data('is-google-pay-allowed');

        if (initialImageContainer.length) {
            // Single image wrapper height;
            singleImageContainerHeigth = $(initialImageContainer[0]).height();
            initialImagesContainerHeight = singleImageContainerHeigth * initialImageContainer.length;
        }

        image.replaceImages();
        imagearrows.reInit();
        variationCarousel.init();
        afterpayFlyin.init(options);
        tabbyInfoFlyin.init();
        variationValidation.init();
        flyin.init(options);
        pdpsize.init();
        toggle.init();
        wishlist.init(true);
        lazyload.init();
        initUniversalRecommendations('product');

        if (resultLength > 7 && result[7].trim()) {
            $('.js-yotpo-widget-placeholder').html(result[7]);
        }
        if (window.yotpoWidgetsContainer) {
            yotpoWidgetsContainer.initWidgets();
        }

        // render the fit predictor and set the product context
        fitPredictor.setProduct();
        fitPredictor.start();

        $('.product-image--preload').addClass('hidden');

        if (isGooglePayAllowed) {
            googlepay.init();
        }

        // update dy delivery message
        $('#dy_delivery-time-msg').html(dyDeliveryMsg);
        if (!$('body').hasClass('pdp-1774')) {
            stickyPanel.init();
            stickyAddToBag.init();
        }

        // update product numbers
        if ($('.variation-productnumber').length) {
            $('.product-number').html($('.product-number-variation').html());
        }

        $('#groupSize').attr('value', getParameterByName('groupSize', href));

        if (resultLength > 2 && $.trim(result[2])) {
            $carouselContainer = $('.product-image-slick');
            const $sliderContainer = $('.slick-product-description');
            $sliderContainer.html(result[2]);
            if ($carouselContainer.length > 0) {
                image.initThumbCarousel();
            }
            if ($('body').hasClass('pdp-1774') && $('.slick-product-description ul.carousel .grid-tile').length > 1) {
                pdp.init1774Slider();
            }
        }
        if (resultLength > 3 && $.trim(result[3])) {
            $('.product-material .product-material-left-img').html(result[3]);
            $('.product-material-left .product-material-left-img').html(result[3]);
        }
        if (resultLength > 4 && $.trim(result[4])) {
            $('.breadcrumb .breadcrumb-element-inner.breadcrumb-productname').html(result[4]);
        }
        if (resultLength > 5 && $.trim(result[5])) {
            $('.olapic-pdp-container').html(result[5]);
        }
        if ($('body').hasClass('pdp-1774') && resultLength > 6 && $.trim(result[6])) {
            $('.product-material-right').html(result[6]);
        }

        if (updateDoneCallback && typeof updateDoneCallback === 'function') {
            updateDoneCallback();
        }

        var $carouselContainer = $('#product-content').find('.us-layout-container');
        var $carouselBubbles = $carouselContainer.find('.slick-dots-custom li');
        $carouselBubbles.eq(activeBubbleIndex).trigger('click');

        calculateInfoPanelMargin();

        // When two colors have different amount of images the page scrolls up/down because the new html is different.
        if (initialImagesContainerHeight && singleImageContainerHeigth && windowScrollTop > 0) {
            let updatedImageContainer = $('.thumbnail-container-slider .slick-list .slick-slide');

            if (updatedImageContainer.length) {
                let firstImg = $(updatedImageContainer[0]).find('img.productthumbnail');

                if (firstImg) {
                    // When the first image is loaded we have the resized heigth.
                    firstImg.on('load', function () {
                        $(window).scrollTop(windowScrollTop);
                        toggle.init();
                    });
                }
            }
        }

        cookie.isAllowed('googletagmanager', isGTMCookieAllowed => {
            gtmTracker.initialDatalayerPush(isGTMCookieAllowed);
        });

        // Updates availability reminder link state
        const isMissingSize = $('.js-product-sizes').data('is-missing-size');
        $('.product-reminder-trigger').toggleClass('hidden', !isMissingSize);
    });
};

/**
 * @description set selected color name in label
 */
var colorPreview = function (selectedValue, $container) {
    if (selectedValue && selectedValue.length && $container && $container.length) {
        $container.find('.attribute-top .selection-text').html(selectedValue);
    }
};

/**
 * Replaces PDP product price content.
 * @param {jQuery Object} $swatch
 * @returns {void}
 */
const replacePDPPriceContent = $swatch => {
    if ($swatch && $swatch.length) {
        const newPriceContent = $swatch.data('price-container');

        if (newPriceContent && newPriceContent.length) {
            const $oldPriceContainer = $swatch.parents('.product-content-top').find('.component.price');

            $oldPriceContainer.replaceWith(newPriceContent);
        }
    }
};

/**
 * Replaces PDP product flags
 * @param {jQuery Object} $swatch
 * @returns {void}
 */
const replacePDPFlags = $swatch => {
    if ($swatch && $swatch.length) {
        const newFlags = $swatch.data('flags');
        const $oldFlagsContainer = $('.product-primary-image-container').find('.product-tile-flag');

        if (newFlags && newFlags.length) {
            const newFlagsContent = productFlags(newFlags, 'pdp');

            $oldFlagsContainer.replaceWith(newFlagsContent);
        } else {
            $oldFlagsContainer.html('');
        }
    }
};

function getCookie(cname) {
    var name = cname + '=';
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return '';
}

$('.order-details-estimated-arrival-date').html(getCookie('narvarDate'));

module.exports = function (options) {
    var $pdpMain = $('#pdpMain');
    options = options || {};
    imagearrows.init();

    // hover on swatch - should update main image with swatch image
    $pdpMain.on('mouseenter mouseleave', '.swatchanchor.color', function () {
        var largeImg = $(this).data('lgimg');
        var $imgZoom = $pdpMain.find('.main-image');
        var $mainImage = $pdpMain.find('.primary-image');

        if (!largeImg) {
            return;
        }
        // store the old data from main image for mouseleave handler
        $(this).data('lgimg', {
            hires: $imgZoom.attr('href'),
            url: $mainImage.attr('src'),
            alt: $mainImage.attr('alt'),
            title: $mainImage.attr('title')
        });
        // set the main image
        image.setMainImage(largeImg);
    });

    // On PDP page load if size is preselected then push GTM Data-layer value
    if (window.dataLayer) {
        let PdpWidthSelected = $pdpMain.find('ul.swatches.width > li.variation-group-value');
        if (PdpWidthSelected.length === 1 && PdpWidthSelected.hasClass('selected')) {
            let widthCurrentSelection = $(PdpWidthSelected).find('.swatchanchor');
            gtmTracker.trackPDPWidthSelected(widthCurrentSelection.data('data-layer'));
        }
    }

    // click on swatch - should replace product content with new variant
    $pdpMain.on('click keypress', '.product-detail:not(.product-set-detail) .swatchanchor', function (e) {
        if (util.isClickOrSpaceOrEnter(e)) {
            $pdpMain.find('.sticky-add-to-bag').find('#add-to-cart-sticky').addClass('add-to-cart-disabled');
            var $this = $(this);
            var $parentLi = $this.parents('li');
            var href = this.href || this.getAttribute('data-href');
            var $carouselContainer = $('.us-layout-container');
            var $carouselBubbles = $carouselContainer.find('.slick-dots-custom li');
            var $activeBubble = $carouselContainer.find('.slick-dots-custom .slick-active');
            activeBubbleIndex = $carouselBubbles.index($activeBubble);
            let isWidth = $this.hasClass('width') && $this.hasClass('width-type');
            let isSize = !!$this.data('size');
            // Capture the width value on PDP buttons click
            if (isWidth) {
                gtmTracker.trackPDPWidthSwitched($this.data('data-layer'));
            }

            if (isSize) {
                optiExperiment.trackEvent('shoe_size_selector_click');
            }

            e.preventDefault();
            if (!isWidth && ($parentLi.hasClass('unselectable') || $parentLi.hasClass('selected'))) {
                return;
            }

            var isColorChange = $this.hasClass('color');

            updateContent($this.data('selectionurl') || href, false, href, options, isColorChange, function () {
                if (isColorChange) {
                    gtmTracker.trackPDPColorSwitched($this.data('data-layer'));
                }
                updateAddToCartButtonState(true, true);
            });
        }
    });

    // change drop down variation attribute - should replace product content with new variant
    $pdpMain.on('change', '.variation-select', function () {
        if (!$(this).val().length) {
            return;
        }

        updateContent($(this).val(), false, null, options, false, function () {
            updateAddToCartButtonState(true, true);
        });
    });

    productZoom.init();

    $pdpMain.on('click keypress', '.size-region a, .attribute.size .form-row-radio.region-select', function (event) {
        // pdp size
        if (util.isClickOrSpaceOrEnter(event)) {
            var $containers = $('.attribute.size'); // change all instances for Product Sets
            var $regionGroups = $containers.find('.sizes .RegionGroup');
            var selectedRegion = '';
            if ($(this).hasClass('form-row-radio')) {
                selectedRegion = $(this).find('input').val();
                var $selectedRadios = $containers.find('input[value="' + selectedRegion + '"]');

                activateRegionGroup($regionGroups, selectedRegion);

                if ($selectedRadios && $selectedRadios.length > 1) {
                    $selectedRadios.parent('span').addClass('checked');
                }
            } else {
                var firstRegion = $(this).first();
                if (firstRegion.length > 0) {
                    selectedRegion = firstRegion.text();
                }

                var $tabLinks = $containers.find('.size-region a');

                $tabLinks.each(function () {
                    $(this).removeClass('tab-selected');
                    $(this).attr('aria-checked', false);
                });
                $(this).addClass('tab-selected');
                $(this).attr('aria-checked', true);
                activateRegionGroup($regionGroups, selectedRegion);
            }
            if (event.originalEvent) {
                optiExperiment.trackEvent('size_selector_click');
            }
            fitPredictor.setProduct();
            fitPredictor.start();
        }
    });

    function activateRegionGroup(regionGroups, selectedRegion) {
        $(regionGroups).removeClass('active activeSize');
        $(regionGroups)
            .filter(function () {
                return $(this).attr('id') === selectedRegion;
            })
            .addClass('active activeSize');
    }

    // hover on color swatch
    $pdpMain.on('mouseover', '.attribute.color li', function () {
        const $swatch = $(this).find('a');
        const $container = $(this).parents('.product-content-top .attribute.color');

        const value = $swatch.data('value');

        colorPreview(value, $container);
        replacePDPPriceContent($swatch);
        replacePDPFlags($swatch);
    });

    $pdpMain.on('mouseout', '.attribute.color li', function () {
        const $container = $(this).parents('.product-content-top .attribute.color');
        const $selectedSwatch = $('.attribute.color li.selected a');

        const value = $container.find('.attribute-top .selection-text').data('value');

        colorPreview(value, $container);
        replacePDPPriceContent($selectedSwatch);
        replacePDPFlags($selectedSwatch);
    });

    // Replace price and color on hover for PDP's with image swatches.
    $pdpMain.on('mouseover', '.grid-tile.variant-image', e => {
        const $swatch = $(e.currentTarget).find('a');
        const $container = $(e.currentTarget).parents('.variations-main-list .attribute.color');

        const value = $swatch.data('value');

        colorPreview(value, $container);
        replacePDPPriceContent($swatch);
        replacePDPFlags($swatch);
    });

    // Revert selected image swatch price and color.
    $pdpMain.on('mouseout', '.grid-tile.variant-image', e => {
        const $container = $(e.currentTarget).parents('.product-content-top .attribute.color');
        const $selectedSwatch = $('.grid-tile.variant-image.selected a');
        const value = $container.find('.attribute-top .selection-text').data('value');

        colorPreview(value, $container);
        replacePDPPriceContent($selectedSwatch);
        replacePDPFlags($selectedSwatch);
    });

    $(window).on('popstate', function (e) {
        var state = e.originalEvent.state;
        if (state) {
            updateContent(state, true, null, options.uniform, false, function () {
                updateAddToCartButtonState(true, true);
            });
        }
    });
    if (history.replaceState) {
        history.replaceState($pdpMain.find('.product-variations').data('currenturl'), null);
    }

    const trackSuccessfullyRegister = $('body').find('input[name="trackSuccessfullyRegister"]')[0];

    if (trackSuccessfullyRegister && trackSuccessfullyRegister.value) {
        optiTracking.pushEventToOptimizely('MEMBERSHIP');
    }

    optiTracking.pushEventToOptimizely('PDP');
    calculateInfoPanelMargin();
};
